import state from './state'
import mutations from './mutations'
import actions from './action'
import getters from './getters'
import integrationMutation from './integrationMutation'

export default {
    namespaced: true,
    state,
    mutations : {
        ...mutations, ...integrationMutation
    },
    actions,
    getters
}
